import $ from 'jquery';

var SiteHeader = {
    initialised: false
};

/**
 * Add event listeners
 */
SiteHeader.init = function () {
    if (this.initialised) {
        return;
    }

    this.$el = $('#header');
    this.$subnav = this.$el.find('.subnav').eq(0);
    this.subnavActive = false;
    this.subnavHiding = false;
    this.currentSelector = null;

    // Affix
    this.$el.find('.navbar-fixed-top').affix({
        offset: {
            top: 80
        }
    });

    this.$el.on('click', 'a', function () {
        $('#header-navbar').collapse('hide');
    }.bind(this));

    this.$el.on('mouseenter', '[data-subnav]', function (e) {
        if (!$(e.target).is("a"))
            return;
        this.showSubnav($(e.currentTarget).data('subnav'));
    }.bind(this));

    this.$el.on('mouseleave', function () {
        this.hideSubnav();
    }.bind(this));

    this.$el.on('show.bs.collapse', '.navbar-collapse', function(e) {
        if ($(e.target).hasClass('navbar-collapse')) {
            $('html').addClass('navbar-open');
        }
    });

    this.$el.on('hide.bs.collapse', '.navbar-collapse', function(e) {
        if ($(e.target).hasClass('navbar-collapse')) {
            $('html').removeClass('navbar-open');
        }
    });

    this.initialised = true;
}

SiteHeader.showSubnav = function (selector) {
    clearTimeout(this.hideTimeout);
    this.subnavHiding = false;

    if (!this.subnavActive) {
        this.$subnav.removeClass('in');
        this.$subnav.addClass('active');
        this.showTimeout = setTimeout(function () {
            this.$subnav.addClass('in');
        }.bind(this), 1);
        this.subnavActive = true;

        $(document).on('mousemove.subnav', function (e) {
            var $el = $(e.target);
            if (!($el.hasClass('subnav') || !!$el.data('subnav') || $el.parents('.subnav').length > 0 || $el.parents('[data-subnav]').length > 0)) {
                this.hideSubnav();
            } else {
                clearTimeout(this.hideTimeout);
                this.subnavHiding = false;
            }
        }.bind(this));
    }

    if (selector === this.currentSelector) {
        return;
    }

    this.currentSelector = selector;
    var $nav = this.$subnav.find('.nav').removeClass('active').filter(selector).addClass('active');
}

SiteHeader.hideSubnav = function () {
    if (!this.subnavActive || this.subnavHiding) {
        return;
    }

    this.subnavHiding = true;

    clearTimeout(this.hideTimeout);
    this.hideTimeout = setTimeout(function () {

        if (!this.subnavActive) {
            return;
        }

        this.subnavActive = this.subnavHiding = false
        $(document).off('mousemove.subnav');

        this.$subnav.removeClass('in');
        this.hideTimeout = setTimeout(function () {
            this.$subnav.removeClass('active');
        }.bind(this), 300);

    }.bind(this), 100);
}

export default SiteHeader;